import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={28}
    fill="none"
    viewBox="0 0 25 28"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.75 2.228h10a2 2 0 012 2v13a2 2 0 01-2 2h-10a2 2 0 01-2-2v-13a2 2 0 012-2zm-4 2a4 4 0 014-4h10a4 4 0 014 4v13a4 4 0 01-4 4h-10a4 4 0 01-4-4v-13zm9.79 21.105a1.895 1.895 0 01-1.895-1.895H6.75a3.79 3.79 0 003.79 3.79h10.42a3.79 3.79 0 003.79-3.79v-13.42a3.79 3.79 0 00-3.79-3.79v1.895c1.047 0 1.895.848 1.895 1.894v13.421a1.895 1.895 0 01-1.895 1.895H10.54z"
      clipRule="evenodd"
    />
  </Icon>
));
